// Generated TypeScript interfaces for template

import { Profession } from '../../supplier/types/model';
import { IntervalTemplate } from './interval_template';
import { TimesheetTemplate } from './timesheet_template';

export interface Template {
  id: number;
  type: Type;
  name: string;
  showInList: boolean;
  professions: Profession[];
  data: TimesheetTemplate | IntervalTemplate;
}

export enum Type {
  TIMESHEET = "timesheet",
  INTERVAL = "interval"
}

